 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLSS_US_ADULT_SIGNUP_FRONT from '@/components/xhtml/SS_US_adult_signup_front'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLDED from '@/components/xhtml/ded'
 import XHTMLPROLOGUE from '@/components/xhtml/prologue'
 import XHTMLCH01 from '@/components/xhtml/ch01'
 import XHTMLCH02 from '@/components/xhtml/ch02'
 import XHTMLCH03 from '@/components/xhtml/ch03'
 import XHTMLCH04 from '@/components/xhtml/ch04'
 import XHTMLCH05 from '@/components/xhtml/ch05'
 import XHTMLCH06 from '@/components/xhtml/ch06'
 import XHTMLCH07 from '@/components/xhtml/ch07'
 import XHTMLCH08 from '@/components/xhtml/ch08'
 import XHTMLCH09 from '@/components/xhtml/ch09'
 import XHTMLCH10 from '@/components/xhtml/ch10'
 import XHTMLCH11 from '@/components/xhtml/ch11'
 import XHTMLCH12 from '@/components/xhtml/ch12'
 import XHTMLCH13 from '@/components/xhtml/ch13'
 import XHTMLCH14 from '@/components/xhtml/ch14'
 import XHTMLCH15 from '@/components/xhtml/ch15'
 import XHTMLCH16 from '@/components/xhtml/ch16'
 import XHTMLCH17 from '@/components/xhtml/ch17'
 import XHTMLCH18 from '@/components/xhtml/ch18'
 import XHTMLCH19 from '@/components/xhtml/ch19'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import XHTMLSS_RECOMMENDPAGE from '@/components/xhtml/SS_recommendpage'
 import TEASER_9781451650990XHTMLSS_TEASER_INTRO_9781451650990 from '@/components/teaser_9781451650990/xhtml/SS_teaser_intro_9781451650990'
 import XHTMLEXCERPT01 from '@/components/xhtml/excerpt01'
 import TEASER_9781451650990XHTMLSS_TEASER_READMORE_9781451650990 from '@/components/teaser_9781451650990/xhtml/SS_teaser_readmore_9781451650990'
 import XHTMLAUTHORBIO from '@/components/xhtml/authorbio'
 import XHTMLALSO from '@/components/xhtml/also'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLSS_US_ADULT_SIGNUP_BACK from '@/components/xhtml/SS_US_adult_signup_back'
 import XHTMLCOPY from '@/components/xhtml/copy'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/SS_US_adult_signup_front",
 			"name" : "xhtml/SS_US_adult_signup_front",
 			"component" : XHTMLSS_US_ADULT_SIGNUP_FRONT
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/ded",
 			"name" : "xhtml/ded",
 			"component" : XHTMLDED
 		},
 		{
 			"path" : "/xhtml/prologue",
 			"name" : "xhtml/prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/ch01",
 			"name" : "xhtml/ch01",
 			"component" : XHTMLCH01
 		},
 		{
 			"path" : "/xhtml/ch02",
 			"name" : "xhtml/ch02",
 			"component" : XHTMLCH02
 		},
 		{
 			"path" : "/xhtml/ch03",
 			"name" : "xhtml/ch03",
 			"component" : XHTMLCH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js